import React from "react";
import styled from "styled-components";

//* assets
import btnCombo from "../../../../../assets/image/01_inicio_y_registro/01_registro_boton_icono_combo.png";
import btnMenu from "../../../../../assets/image/01_inicio_y_registro/01_registro_boton_icono_menu.png";
import btnQR from "../../../../../assets/image/01_inicio_y_registro/01_registro_boton_icono_qr.png";

export const NumberColumns = ({ selectedFilter }) => {
  const monthlyData = [
    { imgSrc: btnCombo, number: 62 },
    { imgSrc: btnMenu, number: 17 },
    { imgSrc: btnQR, number: 34 },
  ];

  const weeklyData = [
    { imgSrc: btnCombo, number: 30 },
    { imgSrc: btnMenu, number: 7 },
    { imgSrc: btnQR, number: 16 },
  ];
  const data = selectedFilter === "semana" ? weeklyData : monthlyData;

  return (
    <NumberContainer>
      <NumberTitle>Descargas</NumberTitle>
      {data.map((item, index) => (
        <NumberCard key={index}>
          <Image src={item.imgSrc} />
          <TextContainer>
            <Number>{item.number}</Number>
          </TextContainer>
        </NumberCard>
      ))}
    </NumberContainer>
  );
};

const NumberContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 100%;
  width: 100%;
`;

const NumberTitle = styled.h2`
  margin: 0px 0px 15px 15px;
  font-size: 1.2em;
  color: #333;
  text-align: center;
  font-family: "Roboto", sans-serif;
`;

const NumberCard = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  // background-color: #fbfafaff;
  margin-bottom: 20px;
  padding: 20px;
  border-radius: 10px;
  width: 80%;
`;

const Image = styled.img`
  max-width: 50%;
  height: auto;
  margin-right: 10px;
  background-color: #af0000;
  border-radius: 5px;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Number = styled.div`
  font-size: 2em;
  font-weight: bold;
  color: #333;
  font-family: "Roboto", sans-serif;
  width: 50px;
  @media (max-width: 808px) {
    font-size: 2em;
  }
`;

const Label = styled.div`
  font-size: 1em;
  color: #666;
`;
